 // import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import "./Demo.css";
// import { Link } from "react-router-dom";


// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import { useSelector, useDispatch } from "react-redux";

// const ReportWithTabs = () => {
//     const { profile } = useSelector((state) => state.userProfile);
//     const dispatch = useDispatch();
  
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accountType, setAccountType] = useState("");
//   const [branch, setBranch] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [accountsData, setAccountsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const rowsPerPage = 5;

// // Load profile on mount
// useEffect(() => {
//   dispatch(fetchUserProfile());
// }, [dispatch]);

// console.log("profile data",profile);
// // Your API call
// const fetchAccounts = async () => {
//   try {
//     setLoading(true);
//     setError("");

//     const superAdminId = profile?.superAdminId || 14;
//     const branchId = profile?.branchId || 8;
//     const createdBy = localStorage.getItem("userId") || 56;

//     const response = await axios.get(
//       "https://payyug.in/api/get-all-saving-account",
//       { params: { superAdminId, branchId, createdBy } }
//     );

//     if (Array.isArray(response.data.accounts)) {
//       setAccountsData(response.data.accounts);
//     } else {
//       setAccountsData([]);
//     }
//   } catch (error) {
//     console.error("API Error:", error);
//     setError("Failed to load saving accounts.");
//   } finally {
//     setLoading(false);
//   }
// };

// // First call on mount
// useEffect(() => {
//   fetchAccounts();
// }, []);




//   // ✅ Tabs: All / Active / Closed / Pre-Closed / Reject
//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     setCurrentPage(1);
//     setSelectedRow(null);
//   };

//   // ✅ Filtered Data
//   const filteredData = useMemo(() => {
//     let data = [...accountsData];
//     console.log("shaving report data: ",data)

//     // Tab filter
//     if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);

//     // Search
//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     // Account Type filter
//     if (accountType) data = data.filter((item) => item.accountType === accountType);

//     // Date filters
//     if (fromDate)
//       data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
//     if (toDate)
//       data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

//     return data;
//   }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

//   // ✅ Pagination
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData =
//     activeTab === "All"
//       ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
//       : filteredData;


//   return (
//     <div className="Demoreport-container">
//       <h2 className="Demo-title">Saving Account Report</h2>

    

//       {/* Filters */}
//       <div className="Demofilters">
//         <input
//           type="text"
//           placeholder="Search by name, account no..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//         <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
//           <option value="">All Account Types</option>
//           <option value="Saving">Saving</option>
//           <option value="Current">Current</option>
//         </select>
//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//         <button className="Demoapply-btn" onClick={() => setCurrentPage(1)}>
//           Apply
//         </button>
//         <button
//           className="Demoreset-btn"
//           onClick={() => {
//             setSearchQuery("");
//             setAccountType("");
//             setFromDate("");
//             setToDate("");
//             setActiveTab("All");
//           }}
//         >
//           Reset
//         </button>
//       </div>

//       {/* Loading / Error States */}
//       {loading && <p className="Demoloading">Loading saving accounts...</p>}
//       {error && <p className="Demoerror">{error}</p>}

//       {/* Table */}
//       <div className="Demotable-container">
//         <table className="Demoreport-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>Status</th>
//               <th>Opened Date</th>
//               <th>Opening Balance</th>
//               <th>Current Balance</th>
//               <th>Share Certificate</th>
//               <th>Passbook</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr key={item.id || index}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{item.accountNumber || "--"}</td>
//                   <td>{item.customerName || "--"}</td>
//                   <td>{item.accountType || "--"}</td>
//                   <td>{item.status || "--"}</td>
//                   <td>{item.openedDate ? item.openedDate.split("T")[0] : "--"}</td>
//                   <td>₹{item.openingBalance || "0"}</td>
//                   <td>₹{item.currentBalance || "0"}</td>
//                   <td><Link className="share-cirtificate-open-btn" to={"/Banking/Report/SharesCertificates"} state={{ row: item }}>Open</Link></td>
//                   <td><Link className="demo-report-open-btn" to={"/Banking/Report/SavingPassbook"} state={{ row: item }}>Open</Link></td>
//                   <td>
//                     <button
//                       className="Demoview-btn"
//                       onClick={() => setSelectedRow(item)}
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 {loading ? <td colSpan="11" style={{ textAlign: "center" }}>
//                   Loading....
//                 </td>:<td colSpan="11" style={{ textAlign: "center" }}>
//                   No Data Found
//                 </td>}
                
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {activeTab === "All" && filteredData.length > rowsPerPage && (
//         <div className="Demopagination">
//           <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1}>
//             Previous
//           </button>
//           <span>
//             Page {currentPage} of {totalPages || 1}
//           </span>
//           <button
//             onClick={() => setCurrentPage((p) => p + 1)}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Detail View */}
//       {selectedRow && (
//         <div className="Demopdf-style-card">
//           <h3>Account Details</h3>
//           <table className="Demopdf-style-table">
//             <tbody>
//               {Object.entries(selectedRow).map(([key, val]) => (
//                 <tr key={key}>
//                   <td>
//                     <strong>{key}</strong>
//                   </td>
//                   <td>{String(val)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReportWithTabs;




import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./Demo.css";
import { Link } from "react-router-dom";

import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { FaEye } from "react-icons/fa";

const ReportWithTabs = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [activeTab, setActiveTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const rowsPerPage = 10;

  /* 🔹 Load profile */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* 🔹 Fetch accounts AFTER profile is ready */
  useEffect(() => {
    if (!profile?.superAdminId || !profile?.branchId) return;
    fetchAccounts();
  }, [profile]);

  const fetchAccounts = async () => {
    try {
      setLoading(true);
      setError("");

      const superAdminId = profile.superAdminId;
      const branchId = profile.branchId;
      const createdBy = localStorage.getItem("userId");

      const response = await axios.get(
        "https://payyug.in/api/get-all-saving-account",
        { params: { superAdminId, branchId, createdBy } }
      );

      setAccountsData(Array.isArray(response.data.accounts) ? response.data.accounts : []);
    } catch (err) {
      console.error(err);
      setError("Failed to load saving accounts.");
    } finally {
      setLoading(false);
    }
  };

  /* 🔹 Filters + Tabs */
  const filteredData = useMemo(() => {
    let data = [...accountsData];

    if (activeTab !== "All") {
      data = data.filter((item) => item.status === activeTab);
    }

    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      data = data.filter((item) =>
        Object.values(item).join(" ").toLowerCase().includes(q)
      );
    }

    if (accountType) {
      data = data.filter((item) => item.accountType === accountType);
    }

    if (fromDate) {
      data = data.filter(
        (item) => new Date(item.openedDate) >= new Date(fromDate)
      );
    }

    if (toDate) {
      data = data.filter(
        (item) => new Date(item.openedDate) <= new Date(toDate)
      );
    }

    return data;
  }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

  /* 🔹 Pagination */
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData =
    activeTab === "All"
      ? filteredData.slice(
          (currentPage - 1) * rowsPerPage,
          currentPage * rowsPerPage
        )
      : filteredData;

  /* 🔹 Reset */
  const handleReset = () => {
    setSearchQuery("");
    setAccountType("");
    setFromDate("");
    setToDate("");
    setActiveTab("All");
    setCurrentPage(1);
    setSelectedRow(null);
  };

  

  const formatValue = (val) => {
  if (val === null || val === undefined || val === "") {
    return "N/A";
  }

  // If object → convert to readable JSON
  // if (typeof val === "object") {
  //   return JSON.stringify(val, null, 2);
  // }

  if (typeof val === "object") {
    if (val?.serviceName) {
      return val.serviceName;
    }
   // return JSON.stringify(val); // fallback if no serviceName
   return "N/A";
  }

  // Date check
  if (typeof val === "string" && !isNaN(Date.parse(val))) {
    return new Date(val)
      .toLocaleDateString("en-GB")
      .replaceAll("/", "-");
  }

  return val;
};


  return (
    <div className="Demoreport-container">
      <h2 className="Demo-title" style={{textAlign:"center"}}>Saving Account Report</h2>

      {/* Filters */}
      <div className="Demofilters">
        <input
          type="text"
          placeholder="Search by name, account no..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          <option value="">All Account Types</option>
          <option value="Saving">Saving</option>
          <option value="Current">Current</option>
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <button className="Demoapply-btn" onClick={() => setCurrentPage(1)}>
          Apply
        </button>

        <button className="Demoreset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>

      {/* Loading / Error */}
      {loading && <p className="Demoloading">Loading saving accounts...</p>}
      {error && <p className="Demoerror">{error}</p>}

      {/* Table */}
      <div className="Demotable-container">
        <table className="Demoreport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Scheme Name</th>
              <th>Opened Date</th>
              <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Status</th>
              <th>Share Certificate</th>
              <th>Passbook</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length ? (
              paginatedData.map((item, index) => (
                <tr className={
                        item.status.toLowerCase() === "closed"
                          ? "closed-row"
                          : item.status.toLowerCase() === "closerequested"
                            ? "requested-row"
                            : ""
                      } key={item.id || index}>
                  <td>
                    {activeTab === "All"
                      ? (currentPage - 1) * rowsPerPage + index + 1
                      : index + 1}
                  </td>
                  <td>{item.accountNumber || "N/A"}</td>
                  <td>{item.customerName || "N/A"}</td>
                  <td>{item.accountType || "N/A"}</td>
                  <td>{item?.schemeDetails?.serviceName || "N/A"}</td>
                  <td>{new Date(item.openedDate).toLocaleDateString("en-GB").replaceAll('/','-') || "--"}</td>
                  <td>₹{item.openingBalance || 0}</td>
                  <td>₹{item.currentBalance || 0}</td>
                  <td className={`Status-${item.status.toLowerCase()}`}>{item.status || "N/A"}</td>
                     <td>
                      {item?.status.toLowerCase()==="active" && (
                    <Link className="share-cirtificate-open-btn"
                      to="/Banking/Report/SharesCertificates"
                      state={{ row: item }}>
                      Open
                    </Link>
                      )}
                  </td>
                  <td>
                     {item?.status.toLowerCase()==="active" && (
                    <Link className="demo-report-open-btn"
                      to="/Banking/Report/SavingPassbook"
                      state={{ row: item }}>
                      Open
                    </Link>
                     )}
                  </td>
                 
                  <td>
                    <button
                      className="Demoview-btn"
                      onClick={() => setSelectedRow(item)}
                    >
                      <FaEye
                        style={{ cursor: "pointer", color: "#f5f5f5", fontSize: "15px" }} 
                        title="View Details"
                      />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  {loading ? "Loading..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {activeTab === "All" && totalPages > 1 && (
        <div className="Demopagination">
          <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button
            onClick={() => setCurrentPage((p) => p + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* Detail View
      {selectedRow && (
        <div className="Demopdf-style-card">
          <h3>Account Details</h3>
          <table className="Demopdf-style-table">
            <tbody>
              {Object.entries(selectedRow).map(([key, val]) => (
                <tr key={key}>
                  <td><strong>{key}</strong></td>
                  <td>{String(val)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}


      {/* Modal Popup */}
      {selectedRow && (
        <div className="Demo-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="Demo-modal-content"
            onClick={(e) => e.stopPropagation()}   // prevent close when clicking inside
          >
            <div className="Demo-modal-header">
              <h3>Account Details</h3>
              <button
                className="Demo-modal-close"
                onClick={() => setSelectedRow(null)}
              >
                ✖
              </button>
            </div>

            <div className="Demo-modal-body">
              <table className="Demopdf-style-table">
                <tbody>
                  {Object.entries(selectedRow).map(([key, val]) => (
                    <tr key={key}>
                      <td><strong>{key}</strong></td>
                      {/* <td>{String(val)}</td> */}
                      <td>{formatValue(val)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="Demo-approve-button"
              onClick={() => setSelectedRow(null)}
            >Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default ReportWithTabs;
